// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__qJA2v","items":"Faq_items__ZZL+W","question":"Faq_question__X9Fb8"};